import qs from 'qs';
import store from '../store';
import { errorTip, getCookie } from '../utils';
import { encryptAuth } from '../utils/crypto';
import { base_java_url } from './baseURL';

/**
 * 状态码响应
 * @param status {Number} http状态码
 * @param content {String} 错误信息
 */
const handleError = (status, content) => {
  switch (status) {
    case 401:
      // 登录失效
      errorTip('登录失效，请重新登录', 2000);
      store.commit('CLEAR_ALL_INFO');
      break;
    case 403:
      errorTip('您没有权限访问该接口', 2000);
      break;
    case 404:
      errorTip('请求出错，该接口不存在', 2000);
      break;
    case 405:
      errorTip(`请求出错 - ${content}`, 2000);
      break;
    default:
      errorTip(`${content}. code: ${status}`, 2000);
      break;
  }
};

export const requestBefore = config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  // 获取登录态
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
  let {
    uin = '',
    token,
    auth,
    st,
    tk,
    language = 0, // 语言默认中文简体
  } = userInfo;
  // 固定的携带参数
  let extraObj = { st, language };

  let loginTime = sessionStorage.getItem('loginTime') || getCookie('loginTime');
  // 携带登录态 和 账号登录时，参数不同。如果有 token，表示是账号登录
  if (token) {
    extraObj.from = 1;
    if (st && loginTime) {
      extraObj.ct =
        parseInt(st, 10) + Math.floor((Date.now() - loginTime) / 1000);
    } else {
      extraObj.ct = Math.round(new Date().getTime() / 1000);
    }
  } else {
    extraObj.from = 2;
    extraObj.ct = userInfo.time;
  }
  if (config.params) {
    if (config.params.cmd && config.params.cmd === 'studio_query_detail') {
      config.params.tk = tk;
    }
  }
  // 处理 参数问题
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...extraObj,
    };
    // 自动添加 uin
    config.params.uin = config.params.uin || uin;
    // 添加 auth 字段
    const newAuth = token ? encryptAuth({ ...config.params, token }) : auth;
    config.params.auth = newAuth;
  } else {
    let data = qs.parse(config.data);
    console.log(data);
    data = { ...data, ...extraObj };
    // 自动添加 uin
    data.uin = data.uin || uin;

    // 添加 auth 字段
    const newAuth = token ? encryptAuth({ ...data, token }) : auth;
    console.log(newAuth);
    // config.data = qs.stringify({ data, auth: newAuth });
    config.data.auth = newAuth;
  }
  if (~config.url.indexOf('/pub/')) {
    console.log('拦截到Java服务器请求', config);
    config.baseURL = base_java_url;
  }
  // } else if (~config.url.indexOf('/log/')) {
  //   console.log('埋点上报');
  //   config.baseURL = base_log_url;
  // }

  return config;
};
export const actRequestBefore = config => {
  if (config.method === 'get') {
    return requestBefore(config);
  }
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  // 获取登录态
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
  let {
    uin = '',
    token,
    auth,
    st,
    language = 0, // 语言默认中文简体
  } = userInfo;
  // 固定的携带参数
  let extraObj = { st, language };

  let loginTime = sessionStorage.getItem('loginTime') || getCookie('loginTime');
  // 携带登录态 和 账号登录时，参数不同。如果有 token，表示是账号登录
  if (token) {
    extraObj.from = 1;
    if (st && loginTime) {
      extraObj.ct =
        parseInt(st, 10) + Math.floor((Date.now() - loginTime) / 1000);
    } else {
      extraObj.ct = Math.round(new Date().getTime() / 1000);
    }
  } else {
    extraObj.from = 2;
    extraObj.ct = userInfo.time;
  }

  // let data = qs.parse(config.data);
  // data = { ...data, ...extraObj };
  // // 自动添加 uin
  // data.uin = data.uin || uin;

  // // 添加 auth 字段
  // const newAuth = token ? encryptAuth({ ...data, token }) : auth;
  // // config.data = qs.stringify({ data, auth: newAuth });
  // config.data.auth = newAuth;
  let act = '';
  if (~config.url.indexOf('act=')) {
    act = config.url.split('act=')[1];
    act = act.split('&')[0];
  }
  let cmd = '';
  if (~config.url.indexOf('cmd=')) {
    cmd = config.url.split('cmd=')[1];
    cmd = cmd.split('&')[0];
  }
  const allParams = { uin, st, language, json: 1, ...extraObj };
  let encryptParams = { ...allParams };
  if (act) {
    encryptParams.act = act;
  }
  if (cmd) {
    encryptParams.cmd = cmd;
  }
  // 添加 auth 字段
  const newAuth = token ? encryptAuth({ ...encryptParams, token }) : auth;

  config.url = config.url + `&${qs.stringify(allParams)}&auth=${newAuth}`;

  return config;
};
export const requestJavaBefore = config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  // 获取登录态
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
  let {
    uin = '',
    token,
    auth,
    st,
    time,
    tk,
    language = 0, // 语言默认中文简体
  } = userInfo;
  // 固定的携带参数
  let extraObj = { st, language };

  let loginTime = sessionStorage.getItem('loginTime') || getCookie('loginTime');
  // 携带登录态 和 账号登录时，参数不同。如果有 token，表示是账号登录
  if (token) {
    extraObj.from = 1;
    if (st && loginTime) {
      extraObj.ct =
        parseInt(st, 10) + Math.floor((Date.now() - loginTime) / 1000);
    } else {
      extraObj.ct = Math.round(new Date().getTime() / 1000);
    }
  } else {
    extraObj.from = 2;
    extraObj.ct = userInfo.time;
  }
  // 处理 参数问题
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...extraObj,
    };
    // 自动添加 uin
    config.params.uin = config.params.uin || uin;
    // 添加 auth 字段
    const newAuth = token ? encryptAuth({ ...config.params, token }) : auth;
    config.params.auth = newAuth;
  } else {
    config.params = {};
    if (token) {
      config.params = {};
      config.params.auth = token;
      config.params.uin = uin;
      config.params.st = st;
      config.params.signType = 1;
    } else {
      config.params.auth = auth;
      config.params.uin = uin;
      config.params.s2t = st;
      config.params.time = time;
    }
  }
  return config;
};
export const requestFail = error => {
  // todo - 错误提示
  return Promise.reject(error);
};

export const responseBefore = response => {
  const { data: res } = response;
  const { code } = res;
  if (code === 0 || code === 500) {
    return res;
  } else {
    if (code === 134) return Promise.reject(res);
    if (code === 218) return res;
    //errorTip(`${res.msg}. code：${code}`);
    errorTip(`${res.msg}`);
    if (code === 166) return location.reload();
    return Promise.reject(res);
  }
};

export const responseFail = error => {
  const { response } = error;
  if (response) {
    if (response.status < 500) {
      handleError(response.status, response.data.msg);
    } else {
      errorTip(`${response.statusText}. code is ${response.status}`, 3000);
    }
  }
  return Promise.reject(error);
};
